import React from 'react';

import CareMapprIconButton from '../../../../../components/Button/CareMapprIconButton';
import editPenOutlineIcon from '../../../../../../assets/img/button-icons/edit-pen-outline.svg';
import TrashIcon from '../../../../../../assets/img/button-icons/trash-red.svg';
import './style.css';
import ConfirmationModal from '../../../../../components/Modal/ConfirmationModal/ConfirmationModal';
import { EditAppointmentForm } from './EditAppointmentForm';
import moment from 'moment';

const AppointmentItem = ({
  appointment,
  canEdit,
  onDelete: onDeleteItem,
  onEditAppointment,
}) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const onConfirmDelete = () => {
    setIsDeleting(false);
    onDeleteItem();
  };

  const onSaveEditAppointment = (values) => {
    onEditAppointment(values);
    setOpenEdit(false);
  };

  const onDelete = () => {
    setIsDeleting(true);
  };
  return (
    <>
      <div className="appointment-row">
        <div className="appointment-row-info">
          <div className="appointment-row-label">{appointment.apptType}</div>
          <div className="appointment-row-sublabel">
            {appointment.apptDate || ''} {appointment.apptTime || ''}
          </div>
        </div>
        {canEdit && (
          <div className="appointment-actions">
            <CareMapprIconButton
              className="medication-button"
              icon={
                <img
                  src={editPenOutlineIcon}
                  className="icon "
                  alt="edit pen icon"
                />
              }
              onClick={() => setOpenEdit(true)}
            />
            <CareMapprIconButton
              className="medication-button"
              icon={<img src={TrashIcon} alt="trash icon" />}
              onClick={onDelete}
            />
          </div>
        )}
        {isDeleting && (
          <ConfirmationModal
            onConfirm={onConfirmDelete}
            onCancel={() => setIsDeleting(false)}
            right="100px"
          />
        )}
      </div>
      {openEdit && (
        <EditAppointmentForm
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          onSave={onSaveEditAppointment}
          values={appointment}
        />
      )}
    </>
  );
};

export default AppointmentItem;
